import { render, staticRenderFns } from "./bizitravelaktarim.vue?vue&type=template&id=7bf2b643&"
import script from "./bizitravelaktarim.vue?vue&type=script&lang=js&"
export * from "./bizitravelaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports